<template>
  <div ref="reward_page" class="RewardPage" @scroll="handleScroll" >
    <div class="data-view" v-if="dataList?.length !== 0">
      <RowLine
        v-for="(item, index) in dataList"
        :key="index"
        :rowData="item.data"
        :curLevel="curLevel"
        :period_id="period_id"
        :isClaiming="claimingState"
        :isLastRow="index == dataList.length-1"
        :isLastTowRow="index == dataList.length-2"
        :isEnding="isEnding"
        :isPro="item.isPro"
        :isLockUpgraded="isLockUpgraded"
        :proMode="proMode"
        @rewardClick="rewardClick"
        @claiming="handleClaiming"
      ></RowLine>
    </div>
    <div class="none-data-view" v-else>
      <RowLine
        v-for="item in skeletonArr"
        :key="item"
        :rowData="item.data"
        :isPro="item.isPro"
        :proMode="proMode"
      ></RowLine>
    </div>
    <!-- 无数据遮罩层 -->
    <div class="RewardPage-mask" v-if="dataList?.length === 0">
      <img :src="require('@/assets/images/YuliApp/weeklyTask/robot_wait.svg')">
      <div class="RewardPage-mask-text">{{ localesPackage?.['og_no_reward_tips']?.[localesEnv] }}</div>
      <div class="RewardPage-mask-text2">{{ localesPackage?.['og_no_reward_tips2']?.[localesEnv] }}</div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, nextTick } from "vue";
import { mapState } from "vuex";
import RowLine from "./components/RowLine";
import { findLastIndexByFieldValue, findIndexByFieldValue, animateNumber } from "@//utils/utils.js";

export default {
  components: {
    RowLine,
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  props: {
    curLevel: {
      type: Number,
      default: 1,
    },
    reward_data: {
      type: Array,
      default: () => [],
    },
    period_id: {
      type: String,
      default: "",
    },
    isClaiming: {
      type: Boolean,
      default: false,
    },
    isLockUpgraded: {
      type: Boolean,
      default: false,
    },
    proMode: {
      type: Boolean,
      default: false,
    },
    animCheckPlayGroup: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    reward_data: {
      handler(value) {
        if (!value || !value?.length) {
          return;
        }
        this.dataList = this.makeTwoDimensionalArrays(value, true);
        if(this.checkPlayGroup?.length > 0){
          this.initPosition('reward-anim');
        }
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    curLevel: {
      handler(value) {
        this.cur_level = value;
        this.initPosition();
      },
      immediate: true,
      deep: true,
    },
    isClaiming: {
      handler(value) {
        this.claimingState = value;
      },
      immediate: true,
      deep: true,
    },
    proMode: {
      handler(value) {
        this.isProMode = value;
      },
      immediate: true,
      deep: true,
    },
    isLockUpgraded: {
      handler(value) {
        this.isLockPro = value;
      },
      immediate: true,
      deep: true,
    },
    animCheckPlayGroup: {
      handler(value) {
        this.checkPlayGroup = value;
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const { curLevel, reward_data, isLockUpgraded } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const cur_row = ref(0);
    const dataList = ref([]);
    const cur_level = ref(curLevel);
    const claimingState = ref(false);
    const reward_page = ref(null);
    const isEnding = ref(false);
    const skeletonArr = ref([]);//无数据时，展示数组
    const isProMode = ref(false);
    const isLockPro = ref(false);// 是否解锁pro
    const checkPlayGroup = ref([]);// check动画数据组
    const checkAnimLock = ref(false);// check动画锁
    const isPlay = ref(false);// check动画播放检查
    onBeforeMount(()=>{
      if (dataList.value?.length === 0) {
        const config = {
          icon_url: '',
          level: 0,
          reward_num: '...',
          isPro: false
        }
        const arr = [
        ...fillArray(30,{...config}),
        // ...fillArray(30,{...config, isPro: true,reward_type: 2})
        ];
        skeletonArr.value = makeTwoDimensionalArrays(arr);
      }
    })
    onMounted(() => {
      // 数量不够时，将触底样式取消
      const clientHeight = reward_page.value.clientHeight;
      const num = dataList.value.length * 108;
      if(num <= clientHeight)isEnding.value = true;
    });

    /**
     * 初始化当前等级所在位置 - 如果存在未领取，优先显示未领取行
     */
    const initPosition = (state = 'normal') => {
      nextTick(() => {
        cur_row.value = Math.floor(cur_level.value / 5); //当前行索引
        const row_el = document.querySelectorAll(".RowLine"); //当前行父元素
        
        //空判断
        if (!row_el || row_el.length === 0) {
          return;
        }

        // 获得当前滚动条高度
        const nowScrollTop = reward_page.value.scrollTop;// 当前滚动条位置
        const clientHeight = reward_page.value.clientHeight;// 当前视窗大小 
        const itemSpace = (row_el.length > 0 && row_el[0].clientHeight) || 0;// 格子间隙

        // 正常mode
        if(state == 'normal'){
          //等级大于5时
          if (cur_level.value > 5) {
            const mul = isProMode.value ? 2 : 1; //判断当前模式 - pro or normal
            let rewardNum = -1;
            for(let i = 0; i < dataList.value.length; i++){
              // 判断是否存在可领取项
              if(dataList.value[i]?.rewardState){
                // 判断是否是pro奖励
                if(dataList.value[i]?.isPro){
                  if(isLockPro.value){
                    rewardNum = i;
                    break;
                  }
                }else {
                  rewardNum = i;
                  break;
                }
              }
            }

            if(rewardNum >= 0) {
              // 可领取情况 - 可领取行优先
              animateNumber(nowScrollTop, row_el[rewardNum]?.offsetTop - 60, 400, (number) => {
                handleposition(number);
              });
            }else {
              // 无可领取情况 - 显示当前等级行
              animateNumber(nowScrollTop, row_el[cur_row.value - 1]?.offsetTop * mul, 400, (number) => {
                handleposition(number);
              });
            }
            return;
          }
        }
        // check动画mode
        else if(state == 'reward-anim'){
          if(checkAnimLock.value)return;
          const playGroup = checkPlayGroup.value;
          //获取播放组 - 起始 和 结束;
          const startNum = findIndexByFieldValue(playGroup,'rewarding',true);
          const endNum = findLastIndexByFieldValue(playGroup,'rewarding',true);
          if(startNum >= 0 && endNum >= 0 && isPlay.value){
            checkAnimLock.value = true;
            const startGroupNum = Math.floor(startNum / 5);
            const endGroupNum = Math.floor(endNum / 5);
            const diff = Math.abs(startGroupNum - endGroupNum) * 168;//差值 * 速率
            const originNum =  row_el[startGroupNum]?.offsetTop - itemSpace; //startGroupNum * 120 - 60;
            const targetNum = endGroupNum == row_el.length - 1 
            ? row_el[endGroupNum-1]?.offsetTop + itemSpace * 2
            : row_el[endGroupNum]?.offsetTop - itemSpace ; //endGroupNum * 120 - 360;
            
            if(targetNum <= (nowScrollTop + clientHeight) - itemSpace * 3){
              checkAnimLock.value = false;
              isPlay.value = false;
              return;
            }
            animateNumber(originNum, targetNum, diff, (number) => {
              handleposition(number);
              // 结束标志
              if(number >= targetNum){
                checkAnimLock.value = false;
                isPlay.value = false;
                checkPlayGroup.value = [];
              }
            });
          }else {
            checkAnimLock.value = false;
            isPlay.value = false;
          }
        }
      });
    };

    /**
     * 定位滚动条的高度
     */
    const handleposition = (scrollTop) => {
      const el = document.querySelector(".RewardPage");
      if (!el) {
        return;
      }
      el.scrollTop = scrollTop;
    };

    /**
     * 接收来自RowLine组件的reward点击事件
     */
    const rewardClick = (level, state, reward_item) => {
      emit("rewardClick", level, state, reward_item);
    };

    /**
     * 处理reward列表 生成二维数组
     */
    const makeTwoDimensionalArrays = (data, isSetScroll = false) => {
      //判断数组是否含有pro
      let hasPro = false;
      const dpArr = data.filter(item => item.isPro);
      if(dpArr.length > 0)hasPro = true;

      //生成二维数组
      let oneArr = [];
      const twoArr = [];
      let isHasReward = false; //判断当前组是否存在可领取状态
      let playEffect = false; //判断当前组是否存在播放项
      data.forEach((item, index) => {
        oneArr.push(item);
        if(item?.state == 1 && !isHasReward)isHasReward = true;
        if(item?.playEffect && !playEffect){
          playEffect = true;
          isPlay.value = true;
        }
        if (oneArr.length === 5) {
          twoArr.push({
            isPro: item.reward_type == 2,
            data: oneArr,
            rewardState: isHasReward,
            playEffect: playEffect,
          });
          oneArr = [];
          isHasReward = false;
          playEffect = false;
        } else if (index === data.length - 1) {
          twoArr.push({
            isPro: item.reward_type == 2,
            data: oneArr,
            rewardState: isHasReward,
            playEffect: playEffect,
          });
          oneArr = [];
          isHasReward = false;
          playEffect = false;
        }
      });

      const resArr = [];//结果存放
      
      // 模式判断
      if(isProMode.value || hasPro){
        //pro模式下 - 数据需要重新整合
        // const mid = Math.floor(twoArr.length/2);
        // const freeReward = twoArr.slice(0,mid);
        // const updateReward = twoArr.slice(mid);
        
        // freeReward.forEach((v,i) => {
        //   resArr.push(freeReward[i]);
        //   resArr.push(updateReward[i]);
        // })
        resArr.push(...twoArr);
      }else{
        resArr.push(...twoArr);
      }

      // console.log('makeTwoDimensionalArrays: ', resArr);
      return resArr;
    };

    /**数组填充器 */
    const fillArray = (length, field) => {
      var arr = [];
      for (var i = 1; i < length+1; i++) {
        var obj = {};
        for (var prop in field) {
          obj[prop] = field[prop];
        }
        obj['level'] = i;
        arr.push(obj);
      }
      return arr;
    }

    /**
     * 处理点击claim限制
     */
    const handleClaiming = (state,reward_item) => {
      emit("claiming", state,reward_item);
    };

    /**
     * 滑动监听处理
     */
     const handleScroll = () => {
      const clientHeight = reward_page.value.clientHeight;
      const scrollTop = reward_page.value.scrollTop;  // 当前滚动高度
      const scrollHeight = reward_page.value.scrollHeight;  // 滚动的总高度
      if (scrollTop + clientHeight >= scrollHeight - 60) {
        // 到达底部，执行相应的操作
        isEnding.value = true;
      }else isEnding.value = false;

    };

    return {
      localesPackage,
      localesEnv,
      dataList,
      cur_row,
      rewardClick,
      makeTwoDimensionalArrays,
      initPosition,
      cur_level,
      claimingState,
      handleClaiming,
      handleScroll,
      reward_page,
      isEnding,
      skeletonArr,
      isProMode,
      isLockPro,
      checkPlayGroup,
    };
  },
};
</script>

<style lang="less" scoped>
.RewardPage {
  position: relative;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg,
    #9289D3 0%,
    #8C8DD4 33%,
    #7A81D1 44%,
    #7C87D0 66%,
    #7084CD 100%
  );
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  &-mask{
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    z-index: 20;
    background: rgba(0, 0,0, 0.8);
    img{
      width: 100px;
      height: 100px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      top: 110px;
    }
    &-text{
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      top: 230px;
    }
    &-text2{
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      font-size: 13px;
      font-weight: 400;
      color: #fff;
      width: 100%;
      text-align: center;
      top: 290px;
    }
  }
}

//隐藏滚动条
.RewardPage::-webkit-scrollbar {
  display: none;
}
.RewardPage {
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: scroll;
  overflow-x: hidden;
}
.data-view{
  padding-top: 0;
}
.none-data-view{
  padding-top: 0;
}
// .RowLine:last-of-type {
//   margin-bottom: 60px;
// }
</style>
